import React, { useState } from 'react';
import { useEasybase } from 'easybase-react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, Radio, RadioGroup, TextField } from '@material-ui/core';

const KursEditDialog = (props) => {
  const [dialogOpen, setDialogOpen] = useState(true);
  const [edName, setEdName] = useState(props.edName);
  const [edDatum, setEdDatum] = useState(props.edDatum);
  const [edZeit, setEdZeit] = useState(props.edZeit);
  const [edMax, setEdMax] = useState(props.edMax);
  const [edAktiv, setEdAktiv] = useState(props.edAktiv);
  const [edBemerkung, setEdBemerkung] = useState(props.edBemerkung);
  const [edKey] = useState(props.edKey);

  const { db, e } = useEasybase();

  const handleClose = () => {
    setDialogOpen(false);
    if (props.fertig !== null) {
      props.fertig(false);
    }
  };

  const handleSave = async () => {
    await db("KURS").where(e.eq('_key', edKey)).set({
      'max': edMax,
      'bemerkung': edBemerkung,
      'aktiv': edAktiv
    }).one().then(updRes => {
      console.log("Result update:" + updRes);
      setDialogOpen(false);
      if (props.fertig !== null) {
        props.fertig(true);
      }
    });
  };

  const handleChange = (event, value) => {
    setEdAktiv(value === "aktiv");
  };

  return (
    <>
      <Dialog open={dialogOpen} onClose={handleClose} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-title">Kurs bearbeiten</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Bitte die Änderungen am Kurs vornehmen und speichern oder abbrechen.
            Falls bei aktivem Kurs das Kennzeichen deaktiviert wird, werden die eMails verschickt.
          </DialogContentText>
          <Box m={1}>
            <TextField label="Kurs" value={edName} fullWidth onChange={e => setEdName(edName)} />
          </Box>
          <Box m={1}>
            <TextField label="Datum" value={edDatum} onChange={e => setEdDatum(edDatum)} />
          </Box>
          <Box m={1}>
            <TextField label="Zeit" value={edZeit} onChange={e => setEdZeit(edZeit)} />
          </Box>
          <Box m={1}>
            <TextField label="Bemerkung" fullWidth value={edBemerkung} onChange={e => setEdBemerkung(e.target.value)} />
          </Box>
          <Box m={1}>
            <TextField label="Max" value={"" + edMax} type="number" inputProps={{ maxLength: 2 }} onChange={e => setEdMax(parseInt(e.target.value))} />
          </Box>
          <Box m={1}>
            <FormControl component="fieldset">
              <RadioGroup row aria-label="aktiv" name="aktiv" value={edAktiv ? "aktiv" : "inaktiv"} onChange={handleChange}>
                <FormControlLabel value="inaktiv" control={<Radio />} label="inaktiv" />
                <FormControlLabel value="aktiv" control={<Radio />} label="aktiv" />
              </RadioGroup>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleSave}>Speichern</Button>
          <Button variant="contained" onClick={handleClose}>Abbrechen</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default KursEditDialog;
